module.exports = __webpack_public_path__ + "img/icon4.4a5b388e.png";